import React, {useEffect, useState} from "react";
import Box from "../../lib/appfuse-react/component/Box";
import Paper from "../../lib/appfuse-react/component/Paper";
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import {Tab} from "@material-ui/core";
import CircularProgress from "../../lib/appfuse-react/component/CircularProgress";
import organizationService from "../../service/organization/organizationService";
import RichText from "../../lib/appfuse-react/component/RichText";
import {makeStyles} from "@material-ui/core/styles";
import {useSelector} from "../../store";
import {isAuthenticated} from "../../reducer/iam/authReducer";
import {withDesktop} from "../../layout/Desktop";
import {withExplorer} from "../../layout/Explorer";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";

function CourseFeeContent() {
    const [tabValue, setTabValue] = useState(0);
    const [value, setValue] = useState({});
    const [ready, setReady] = useState(false);

    useEffect(() => {
        (async () => {
            const data = await organizationService.get();
            setValue(data);
            setReady(true);
        })();
    }, []);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();
    const padding = isMobile? 0:4;

    return (
        <Box fullHeight fullWidth>
            <CircularProgress value={ready} fullWidth fullHeight backgroundColor='white'>
                <Paper fullWidth fullHeight square variant='outlined'>
                    <TabContext value={tabValue}>
                        <Box display='flex' flexDirection='column' fullHeight padding={padding}>
                            <Paper>
                                <TabList onChange={handleChangeTab} textColor='primary' style={{paddingTop: '1rem', paddingLeft: '2rem'}}>
                                    {feeType.map(type => <Tab key={type.code} label={type.text}/>)}
                                </TabList>
                            </Paper>
                            <Box fullWidth fullHeight overflow='hidden'>
                                {feeType.map((type, index) => <FeeTabPanel index={index} value={value[type.code]}/>)}
                            </Box>
                        </Box>
                    </TabContext>
                </Paper>
            </CircularProgress>
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    tabPanel: {
        height: '100%',
        overflow: 'hidden',
        padding: '0px'
    }
}));

function FeeTabPanel(props) {
    const {index, value={}} = props;
    const classes = useStyles();

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();
    const padding = isMobile? 2:4;

    return (
        <TabPanel value={index} className={classes.tabPanel}>
            <Box fullWidth fullHeight display='flex' flexDirection='column' overflow='hidden' paddingY={2}>
                <Box fullWidth overflow='auto' paddingY={2} paddingX={padding}>
                    <RichText value={value} fullWidth overflow='visible'/>
                </Box>
            </Box>
        </TabPanel>
    );
}

const feeType = [
    {code: 'discountDescription', text: '優惠方式'},
    {code: 'paymentDescription', text: '繳費方式'}
]

function CourseFee() {
    const authenticated = useSelector(isAuthenticated);

    return authenticated? withDesktop(CourseFeeContent)():withExplorer(CourseFeeContent)();
}

export default CourseFee;